export const GET_MERCHANT_LIST = 'GET_MERCHANT_LIST';
export const SET_MERCHANT_LIST = 'SET_MERCHANT_LIST';
export const GET_MERCHANT_DETAILS = 'GET_MERCHANT_DETAILS';
export const SET_MERCHANT_DETAILS = 'SET_MERCHANT_DETAILS';
export const CLEAR_MERCHANT_VIEW = 'CLEAR_MERCHANT_VIEW';
export const UPDATE_MERCHANT_STATUS = 'UPDATE_MERCHANT_STATUS';
export const RESEND_APPROVED_NOTIFICATION_TO_MERCHANT = 'RESEND_APPROVED_NOTIFICATION_TO_MERCHANT';
